import { render } from "./CourseEnd.vue?vue&type=template&id=2c7a363a&scoped=true"
import script from "./CourseEnd.vue?vue&type=script&lang=js"
export * from "./CourseEnd.vue?vue&type=script&lang=js"

import "./CourseEnd.vue?vue&type=style&index=0&id=2c7a363a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2c7a363a"

export default script